import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponse } from 'src/app/shared/models/api-response.model';
import { ProcessActionTrackingViewModel, RequestSearchResultDto, RequestsSearchDto } from '../models/request-models';
import { SearchDto1 } from 'src/app/shared/models/paging/request/search-dto';

@Injectable({ providedIn: 'root' })
export class ProcessService {
  public notificationCount:string = '0';
  public referralLandingNotificationCount:number = -1;

  constructor(private http: HttpClient) {
  }

  getInbox(requestsSearchDto: RequestsSearchDto): Observable<ApiResponse<SearchDto1<RequestSearchResultDto>>> {
    return this.http.post<ApiResponse<SearchDto1<RequestSearchResultDto>>>( '/api/Process/GetInbox', requestsSearchDto);
  }

//   getAllUsersInbox(requestsSearchDto: RequestsSearchDto): Observable<ApiResponse<RequestsSearchDto>> {
//     return this.http.post<ApiResponse<RequestsSearchDto>>('/api/process/GetAllUsersInbox', requestsSearchDto);
//   }

  getNotificationCount(): Observable<ApiResponse<number>> {
    return this.http.get<ApiResponse<number>>('/api/process/GetNotificationCount');
  }

  // getTaskDecision(taskDecisionSearchDto: TaskDecisionSearchDto): Observable<ApiResponse<TaskDecisionDto>> {
  //   return this.http.post<ApiResponse<TaskDecisionDto>>('/api/process/GetTaskDecision', taskDecisionSearchDto);
  // }

//   saveTaskDecision(taskDecisionDto: TaskDecisionDto): Observable<ApiResponse<string>> {
//     return this.http.post<ApiResponse<string>>('/api/process/SaveTaskDecision', taskDecisionDto);
//   }

//   getProcessStatusList(processId?: number): Observable<ApiResponse<SelectListItem[]>> {

//     if(processId == null){
//       return this.http.get<ApiResponse<SelectListItem[]>>('/api/process/GetProcessStatusList');
//     }
//     return this.http.get<ApiResponse<SelectListItem[]>>(`/api/process/GetProcessStatusList?processId=${processId}`);
//   }

//   getProcessTypesList(): Observable<ApiResponse<SelectListItem[]>> {
//     return this.http.get<ApiResponse<SelectListItem[]>>(`/api/process/GetProcessTypesList`);
//   }
  // isRequestExist(id: string): Observable<ApiResponse<boolean>> {
  //   return this.http.post<ApiResponse<boolean>>(environment.apiUrl + this.controllerName + '/GetIsRequestExist',{ id });
  // }

  // GetTasksCount() {
  //   return this.http.post<ApiResponse<number>>(environment.apiUrl + this.controllerName + '/GetTasksCount',null);
  // }
}
